// src/components/common/FilterPill.tsx
interface FilterPillProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
  children?: React.ReactNode;
}

export function FilterPill({
  label,
  isSelected,
  onClick,
  className = '',
  children,
}: FilterPillProps) {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 text-sm rounded-lg transition-all duration-150 ${
        isSelected
          ? 'bg-primary-600 text-white shadow-sm shadow-primary/25'
          : 'bg-neutral-100 dark:bg-neutral-800/60 text-neutral-600 dark:text-neutral-400 hover:bg-primary/10 hover:text-primary dark:hover:bg-primary/10 dark:hover:text-primary-300'
      } ${className}`}
    >
      {children || label}
    </button>
  );
}
